import { render, staticRenderFns } from "./SxTreeViewAddOrUpdate.vue?vue&type=template&id=00419917&scoped=true&"
import script from "./SxTreeViewAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SxTreeViewAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00419917",
  null
  
)

export default component.exports